import { ILogin, ILoginResponseDTO } from '../interfaces/login.interface';

export class AuthMapper {
  static fromDTO(dto: ILoginResponseDTO): ILogin {
    return {
      accessToken: dto.token,
      refreshToken: dto.refreshToken,
    };
  }
}
